import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const registerForWebinar = async (registrationData) => {
  try {
    const response = await axios.post(`${API}/register`, registrationData);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.detail || 'Registration failed');
    }
    throw new Error('Network error. Please try again.');
  }
};

export const getRegistrations = async () => {
  try {
    const response = await axios.get(`${API}/registrations`);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.detail || 'Failed to fetch registrations');
    }
    throw new Error('Network error. Please try again.');
  }
};
